<template>
    <div
        class="standard caculator-container"
        :class="info.nodisclosureDes != null ? 'nodisclosure' : ''"
    >
        <div v-if="!info.pricePerMonth" @click="openCaculator('standard')">
            <span class="iconfont icon-caculator">
                <span class="payment-text">{{
                    $t('md-detail-info.estPayment')
                }}</span>
            </span>
            <label>
                {{
                    $ft.formatCurrency({
                        value: info.nodisclosureDes != null ? '-' : pricePerMonth,
                        noSpace: true,
                        currencySymbol
                    })
                }} </label>{{ $t('md-detail-info.mo') }}
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['openCaculator', 'showSoldPrice'],
    data: function() {
        return {};
    },
    computed: {
        ...rootMapState(usePageStore, {
            "house": store => store.page?.house || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        ...mapState({
            "pricePerMonth": store => store.pricePerMonth,
            "info": store => store.listingDetail.info || {}
        }),
        hidePrice() {
            return (
                !this.house.showListingPrice &&
                !this.showSoldPrice &&
                this.info.listingStatus == 'Sold'
            );
        }
    },
    methods: {}
};
</script>
<style lang="scss">
.standard.caculator-container {
    cursor: pointer;
    &.nodisclosure {
        opacity: 0.4;
        .icon-caculator {
            cursor: initial;
        }
    }
    label {
        padding-right: 4px;
    }
    .cal {
        margin-left: 15px;
        color: var(--color-label);
        font-size: 16px;
        cursor: pointer;
    }
    .icon-caculator {
        cursor: pointer;
        .payment-text {
            font-size: 12px;
            margin-left: 5px;
            margin-right:10px;
            color: var(--color-disable);
        }
    }
}
</style>
